export const GET_COMPANY_DETAILS = "GET_COMPANY_DETAILS"
export const GET_PORTFOLIO = "GET_PORTFOLIO"
export const GET_TECHSTACK = "GET_TECHSTACK"
export const GET_TEAM_MEMBERS = "GET_TEAM_MEMBERS"
export const PORTFOLIO_HOVER_SHOW = "PORTFOLIO_HOVER_SHOW"
export const PORTFOLIO_HOVER_HIDE = "PORTFOLIO_HOVER_HIDE"
export const CHANGE_ACTIVE_CLASS = "CHANGE_ACTIVE_CLASS"
export const TEAM_CARD_HOVER_SHOW = "TEAM_CARD_HOVER_SHOW"
export const TEAM_CARD_HOVER_HIDE = "TEAM_CARD_HOVER_HIDE"
